import './Footer.css';
import logo from '../../assets/logo.png'; // update to your actual path
import facebook from "../../../assests/facebook.png"
import instagram from "../../../assests/instagram.png"
import linkdein from "../../../assests/linkedin.png"
import whatsapp from "../../../assests/whatsapp.png"
const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-top">
                <h2>MAKE YOUR BUSINESS IDEAS COME TRUE</h2>
                <button className="quote-btn"><a href='/contact'>GET A QOUTE</a></button>
            </div>
            {/* 
            <div className="footer-contact-row">
                <div className="footer-contact-item">
                    <h5>SEND EMAIL</h5>
                    <p>needhelp@company.com</p>
                </div>
                <div className="footer-center-logo">
                    <img src={logo} alt="DIGIMA" />
                    wwwwwwwwwwww
                </div>
                <div className="footer-contact-item">
                    <h5>CALL NOW</h5>
                    <p>+92 ( 4680 ) 66 - 8800</p>
                </div>
            </div> */}

            <div className="footer-columns">
                <div className="footer-column">
                    <h4>ABOUT</h4>
                    <p>
                        Welcome to our web design agency. Lorem ipsum simply free text dolor sited amet cons cing elit.
                    </p>
                </div>
                <div className="footer-column">
                    <h4>EXPLORE</h4>
                    <a href="#">Meet Our Team</a>
                    <a href="#">What We Do</a>
                    <a href="#">Latest News</a>
                    <a href="#">Contact</a>
                </div>
                <div className="footer-column">
                    <h4>CONTACT</h4>
                    <p>60 Road, Brooklyn Golden Street New York. USA</p>
                    <div className="footer-social-icons">
                        <i><img src={facebook} alt="Facebook" /></i>
                        <i><img src={instagram} alt="Instagram" /></i>
                        <i><img src={whatsapp} alt="WhatsApp" /></i>
                        <i><img src={linkdein} alt="LinkedIn" /></i>
                    </div>

                </div>
                <div className="footer-column">
                    <h4>NEWSLETTER</h4>
                    <p>Subscribe for our upcoming latest articles and news resources</p>
                    <div className="footer-newsletter">
                        <input type="text" placeholder="Your email" />
                        <button>
                            <i className="fa fa-paper-plane"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                © Copyright 2026 by PAPA DIGITAL SOLUTION
                <div>
                    <a href="/login">Login</a>
                </div>
            </div>

        </footer>
    );
};

export default Footer;
